import React, { useEffect, useMemo, useState } from "react";
import { useTable, useFilters, useSortBy } from "react-table";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import { useAuth } from "pages/context/AuthContext";
import PageHeader from "pages/components/PageHeader";

import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BlockIcon from "@mui/icons-material/Block";
import TableViewIcon from "@mui/icons-material/TableView";
import AltRouteIcon from "@mui/icons-material/AltRoute";

function PaperComponent(props) {
  return (
    <Draggable handle=".draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

function TextFilter({ column: { filterValue, setFilter } }) {
  return (
    <input
      value={filterValue || ""}
      onChange={(e) => setFilter(e.target.value || undefined)}
      placeholder="filtrar..."
      style={{
        width: "100%",
        padding: "6px 4px",
        border: "none",
        borderBottom: "1px solid rgba(0,0,0,0.2)",
        outline: "none",
        background: "transparent",
        fontSize: 12,
        color: "#556",
      }}
    />
  );
}

function AtivoFilter({ column: { filterValue, setFilter } }) {
  return (
    <select
      value={filterValue || ""}
      onChange={(e) => setFilter(e.target.value || undefined)}
      style={{
        width: "100%",
        padding: "6px 4px",
        border: "none",
        borderBottom: "1px solid rgba(0,0,0,0.2)",
        outline: "none",
        background: "transparent",
        fontSize: 12,
        color: "#556",
      }}
    >
      <option value="">Todos</option>
      <option value="0">Ativos</option>
      <option value="1">Inativos</option>
    </select>
  );
}

const FILTERS_KEY = "tbl:clientesacordosmateriais:filters";
const KEEP_KEY = "tbl:clientesacordosmateriais:keep";

const clienteLabel = (c) => (c?.nome ? `${c.nome} (${c.ref})` : "");

const fabricanteLabel = (f) => (f?.nome ? `${f.nome} (${f.ref})` : "");

const materialLabel = (m) => (m?.nome ? `${m.nome} (${m.ref})` : "");

export default function ClientesAcordosMateriais() {
  const { showAlert } = useAlert();
  const { temPermissao, userData } = useAuth();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const [clientesCombo, setClientesCombo] = useState([]);
  const [fabricantesCombo, setFabricantesCombo] = useState([]);
  const [materiaisCombo, setMateriaisCombo] = useState([]);
  const [fabricantesAcordosCombo, setFabricantesAcordosCombo] = useState([]);

  const [clienteInput, setClienteInput] = useState("");
  const [fabricanteInput, setFabricanteInput] = useState("");
  const [materialInput, setMaterialInput] = useState("");

  const [alternativaInput, setAlternativaInput] = useState("");
  const [openDialogAlternativos, setOpenDialogAlternativos] = useState(false);
  const [acordoAlternativosSelecionado, setAcordoAlternativosSelecionado] = useState(null);
  const [alternativosAcordo, setAlternativosAcordo] = useState([]);

  const [formAlternativo, setFormAlternativo] = useState({
    id: null,
    idclienteacordomaterial: null,
    refmaterialalternativo: "",
    tipodesconto: "",
    valor_percentagem: "",
    valor_eur: "",
    suporte_jf_perc: "",
    suporte_fabricante_perc: "",
    obs: "",
    inativo: 0,
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [editando, setEditando] = useState(false);

  const [openDialogValorReceber, setOpenDialogValorReceber] = useState(false);
  const [valorReceberData, setValorReceberData] = useState([]);
  const [loadingExcelValorReceber, setLoadingExcelValorReceber] = useState(false);
  const [valorFabricanteInput, setValorFabricanteInput] = useState("");
  const [valorReceberForm, setValorReceberForm] = useState({
    reffabricante: "",
    datainicial: "",
    datafinal: "",
  });

  const [form, setForm] = useState({
    id: null,
    refcliente: "",
    reffabricante: "",
    refmaterial: "",
    tipodesconto: "PERCENTAGEM",
    valor_percentagem: "",
    valor_eur: "",
    suporte_jf_perc: 100,
    suporte_fabricante_perc: 0,
    datainicial: "",
    datafinal: "",
    utilizacao_unica: 0,
    obs: "",
    inativo: 0,
  });

  const initialKeep =
    (() => {
      try {
        const v = localStorage.getItem(KEEP_KEY);
        return v === null ? true : JSON.parse(v);
      } catch {
        return true;
      }
    })() ?? true;

  const [keepFilters, setKeepFilters] = useState(initialKeep);

  const initialFilters = keepFilters
    ? (() => {
        try {
          return JSON.parse(localStorage.getItem(FILTERS_KEY) || "[]");
        } catch {
          return [];
        }
      })()
    : [];

  const carregar = async () => {
    setLoading(true);
    const [payload, err] = await handleApi(
      api.post("ClientesAcordosMateriais/SelClientesAcordosMateriais", {})
    );
    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setData(Array.isArray(payload) ? payload : []);
  };

  const carregarClientesCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelClientesCampanhasCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setClientesCombo(Array.isArray(payload) ? payload : []);
  };

  const carregarFabricantesCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelFabricantesCampanhasCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setFabricantesCombo(Array.isArray(payload) ? payload : []);
  };

  const carregarFabricantesAcordosCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("ClientesAcordosMateriais/SelFabricantesAcordosMateriaisCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setFabricantesAcordosCombo(Array.isArray(payload) ? payload : []);
  };

  const carregarMateriaisCombo = async (term = "") => {
    const [payload, err] = await handleApi(
      api.post("Campanhas/SelMateriaisCampanhasCombo", { term })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setMateriaisCombo(Array.isArray(payload) ? payload : []);
  };

  useEffect(() => {
    carregar();
    carregarClientesCombo();
    carregarFabricantesCombo();
    carregarMateriaisCombo();
  }, []);

  const limparForm = () => {
    setForm({
      id: null,
      refcliente: "",
      reffabricante: "",
      refmaterial: "",
      tipodesconto: "PERCENTAGEM",
      valor_percentagem: "",
      valor_eur: "",
      suporte_jf_perc: 100,
      suporte_fabricante_perc: 0,
      datainicial: "",
      datafinal: "",
      utilizacao_unica: 0,
      obs: "",
      inativo: 0,
    });

    setClienteInput("");
    setFabricanteInput("");
    setMaterialInput("");
  };

  const abrirNovo = () => {
    setEditando(false);
    limparForm();
    setOpenDialog(true);
  };

  const abrirEditar = (row) => {
    setEditando(true);

    setForm({
      id: row.id,
      refcliente: row.refcliente || "",
      reffabricante: row.reffabricante || "",
      refmaterial: row.refmaterial || "",
      tipodesconto: row.tipodesconto || "PERCENTAGEM",
      valor_percentagem: row.valor_percentagem ?? "",
      valor_eur: row.valor_eur ?? "",
      suporte_jf_perc: row.suporte_jf_perc ?? 100,
      suporte_fabricante_perc: row.suporte_fabricante_perc ?? 0,
      datainicial: row.datainicial ? String(row.datainicial).substring(0, 10) : "",
      datafinal: row.datafinal ? String(row.datafinal).substring(0, 10) : "",
      utilizacao_unica: Number(row.utilizacao_unica || 0),
      obs: row.obs || "",
      inativo: Number(row.inativo || 0),
    });

    setClienteInput(row.cliente ? `${row.cliente} (${row.refcliente})` : "");
    setFabricanteInput(row.fabricante ? `${row.fabricante} (${row.reffabricante})` : "");

    setMaterialInput(row.material ? `${row.material} (${row.refmaterial})` : row.refmaterial || "");

    setOpenDialog(true);
  };

  const guardar = async () => {
    if (!form.refcliente || !form.reffabricante || !form.refmaterial) {
      showAlert("Preenche cliente, fabricante e material.", "warning");
      return;
    }

    if (form.tipodesconto === "PERCENTAGEM" && Number(form.valor_percentagem || 0) <= 0) {
      showAlert("Indica a percentagem de desconto.", "warning");
      return;
    }

    if (form.tipodesconto === "VALOR" && Number(form.valor_eur || 0) <= 0) {
      showAlert("Indica o valor em euros.", "warning");
      return;
    }

    const totalSuporte =
      Number(form.suporte_jf_perc || 0) + Number(form.suporte_fabricante_perc || 0);

    if (Math.round(totalSuporte * 1000000) / 1000000 !== 100) {
      showAlert("A soma do suporte JF e fabricante tem de ser 100%.", "warning");
      return;
    }

    setLoading(true);

    const body = {
      ...form,
      valor_percentagem:
        form.tipodesconto === "PERCENTAGEM" ? Number(form.valor_percentagem || 0) : null,
      valor_eur: form.tipodesconto === "VALOR" ? Number(form.valor_eur || 0) : null,
      suporte_jf_perc: Number(form.suporte_jf_perc || 0),
      suporte_fabricante_perc: Number(form.suporte_fabricante_perc || 0),
      datainicial: form.datainicial || null,
      datafinal: form.datafinal || null,
      utilizacao_unica: Number(form.utilizacao_unica || 0),
      inativo: Number(form.inativo || 0),
      criado_por: userData?.id || null,
      atualizado_por: userData?.id || null,
    };

    const endpoint = editando
      ? "ClientesAcordosMateriais/UpdClienteAcordoMaterial"
      : "ClientesAcordosMateriais/InsClienteAcordoMaterial";

    const [_, err, meta] = await handleApi(api.post(endpoint, body));

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Desconto adicional gravado.", meta?.severity || "success");

    setOpenDialog(false);
    await carregar();
  };

  const abrirValorReceber = () => {
    setValorReceberData([]);
    setValorFabricanteInput("");
    setValorReceberForm({
      reffabricante: "",
      datainicial: "",
      datafinal: "",
    });
    carregarFabricantesAcordosCombo();
    setOpenDialogValorReceber(true);
  };

  const consultarValorReceber = async () => {
    if (!valorReceberForm.reffabricante) {
      showAlert("Seleciona o fabricante.", "warning");
      return;
    }

    if (!valorReceberForm.datainicial || !valorReceberForm.datafinal) {
      showAlert("Indica a data inicial e a data final.", "warning");
      return;
    }

    setLoading(true);

    const [payload, err] = await handleApi(
      api.post("ClientesAcordosMateriais/SelValorReceberFabricante", valorReceberForm)
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    setValorReceberData(Array.isArray(payload) ? payload : []);
  };

  const totalValorReceberFabricante = valorReceberData.reduce(
    (acc, row) => acc + Number(row.valor_receber_fabricante || 0),
    0
  );

  const formatarValor = (valor) =>
    Number(valor || 0).toLocaleString("pt-PT", {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3,
    });

  const exportarValorReceberExcel = async () => {
    if (!valorReceberForm.reffabricante) {
      showAlert("Seleciona o fabricante.", "warning");
      return;
    }

    if (!valorReceberForm.datainicial || !valorReceberForm.datafinal) {
      showAlert("Indica a data inicial e a data final.", "warning");
      return;
    }

    try {
      setLoadingExcelValorReceber(true);

      const res = await api({
        url: "ClientesAcordosMateriais/ExportarValorReceberFabricante",
        method: "post",
        data: valorReceberForm,
        responseType: "arraybuffer",
      });

      const contentDisposition = res.headers["content-disposition"] || "";

      let fileName = `AcordosPrecos_${new Date()
        .toISOString()
        .slice(2, 16)
        .replace(/[-:T]/g, "")
        .replace(/^(\d{6})(\d{4})$/, "$1_$2")}.xlsx`;

      const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
      const normalMatch = contentDisposition.match(/filename="?([^"]+)"?/i);

      if (utf8Match?.[1]) {
        fileName = decodeURIComponent(utf8Match[1]);
      } else if (normalMatch?.[1]) {
        fileName = normalMatch[1];
      }

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      showAlert("Excel gerado com sucesso.", "success");
    } catch (err) {
      showAlert("Erro ao gerar Excel.", "error");
    } finally {
      setLoadingExcelValorReceber(false);
    }
  };

  const limparFormAlternativo = () => {
    setAlternativaInput("");
    setFormAlternativo({
      id: null,
      idclienteacordomaterial: acordoAlternativosSelecionado?.id || null,
      refmaterialalternativo: "",
      tipodesconto: "",
      valor_percentagem: "",
      valor_eur: "",
      suporte_jf_perc: "",
      suporte_fabricante_perc: "",
      obs: "",
      inativo: 0,
    });
  };

  const carregarAlternativosAcordo = async (idclienteacordomaterial) => {
    if (!idclienteacordomaterial) return;

    const [payload, err] = await handleApi(
      api.post("ClientesAcordosMateriais/SelClienteAcordoMaterialAlternativos", {
        idclienteacordomaterial,
      })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setAlternativosAcordo(Array.isArray(payload) ? payload : []);
  };

  const abrirAlternativos = async (acordo) => {
    setAcordoAlternativosSelecionado(acordo);
    setAlternativosAcordo([]);
    setOpenDialogAlternativos(true);

    setFormAlternativo({
      id: null,
      idclienteacordomaterial: acordo.id,
      refmaterialalternativo: "",
      tipodesconto: "",
      valor_percentagem: "",
      valor_eur: "",
      suporte_jf_perc: "",
      suporte_fabricante_perc: "",
      obs: "",
      inativo: 0,
    });

    setAlternativaInput("");

    await carregarAlternativosAcordo(acordo.id);
  };

  const editarAlternativo = (alt) => {
    setFormAlternativo({
      id: alt.id,
      idclienteacordomaterial: alt.idclienteacordomaterial,
      refmaterialalternativo: alt.refmaterialalternativo || "",
      tipodesconto: alt.tipodesconto || "",
      valor_percentagem: alt.valor_percentagem ?? "",
      valor_eur: alt.valor_eur ?? "",
      suporte_jf_perc: alt.suporte_jf_perc ?? "",
      suporte_fabricante_perc: alt.suporte_fabricante_perc ?? "",
      obs: alt.obs || "",
      inativo: Number(alt.inativo || 0),
    });

    setAlternativaInput(
      alt.materialalternativo
        ? `${alt.materialalternativo} (${alt.refmaterialalternativo})`
        : alt.refmaterialalternativo || ""
    );
  };

  const guardarAlternativo = async () => {
    if (!formAlternativo.idclienteacordomaterial) {
      showAlert("Acordo principal inválido.", "error");
      return;
    }

    if (!formAlternativo.refmaterialalternativo) {
      showAlert("Indica o material alternativo.", "warning");
      return;
    }

    if (
      formAlternativo.tipodesconto === "PERCENTAGEM" &&
      Number(formAlternativo.valor_percentagem || 0) <= 0
    ) {
      showAlert("Indica a percentagem do alternativo.", "warning");
      return;
    }

    if (formAlternativo.tipodesconto === "VALOR" && Number(formAlternativo.valor_eur || 0) <= 0) {
      showAlert("Indica o valor em euros do alternativo.", "warning");
      return;
    }

    const body = {
      ...formAlternativo,
      tipodesconto: formAlternativo.tipodesconto || null,
      valor_percentagem:
        formAlternativo.tipodesconto === "PERCENTAGEM"
          ? Number(formAlternativo.valor_percentagem || 0)
          : null,
      valor_eur:
        formAlternativo.tipodesconto === "VALOR" ? Number(formAlternativo.valor_eur || 0) : null,
      suporte_jf_perc:
        formAlternativo.suporte_jf_perc === "" ? null : Number(formAlternativo.suporte_jf_perc),
      suporte_fabricante_perc:
        formAlternativo.suporte_fabricante_perc === ""
          ? null
          : Number(formAlternativo.suporte_fabricante_perc),
      criado_por: userData?.id || null,
      atualizado_por: userData?.id || null,
    };

    const endpoint = formAlternativo.id
      ? "ClientesAcordosMateriais/UpdClienteAcordoMaterialAlternativo"
      : "ClientesAcordosMateriais/InsClienteAcordoMaterialAlternativo";

    setLoading(true);
    const [_, err, meta] = await handleApi(api.post(endpoint, body));
    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Alternativo gravado.", meta?.severity || "success");

    await carregarAlternativosAcordo(formAlternativo.idclienteacordomaterial);
    limparFormAlternativo();
  };

  const inativarAlternativo = async (alt) => {
    if (!alt?.id) return;

    setLoading(true);

    const [_, err, meta] = await handleApi(
      api.post("ClientesAcordosMateriais/InativarClienteAcordoMaterialAlternativo", {
        id: alt.id,
        atualizado_por: userData?.id || null,
      })
    );

    setLoading(false);

    if (err) {
      showAlert(err, "error");
      return;
    }

    showAlert(meta?.message || "Alternativo inativado.", meta?.severity || "success");

    await carregarAlternativosAcordo(alt.idclienteacordomaterial);
  };

  const columns = useMemo(
    () => [
      {
        Header: "",
        id: "acoes",
        disableFilters: true,
        width: 72,
        minWidth: 56,
        maxWidth: 90,
        Cell: ({ row }) => {
          const a = row.original;

          return (
            <div style={{ display: "flex", gap: 4, whiteSpace: "nowrap" }}>
              <IconButton
                size="small"
                color="primary"
                disabled={!temPermissao("Menu Acordos Cliente/Fabricante", "u")}
                onClick={() => abrirEditar(a)}
                title="Editar desconto"
              >
                <EditIcon fontSize="small" />
              </IconButton>

              <IconButton
                size="small"
                color="secondary"
                disabled={!temPermissao("Menu Acordos Cliente/Fabricante", "u")}
                onClick={() => abrirAlternativos(a)}
                title="Materiais alternativos"
              >
                <AltRouteIcon fontSize="small" />
              </IconButton>
            </div>
          );
        },
      },
      { Header: "Cliente", accessor: "cliente", Filter: TextFilter },
      { Header: "Ref. Cliente", accessor: "refcliente", Filter: TextFilter },
      { Header: "Fabricante", accessor: "fabricante", Filter: TextFilter },
      { Header: "Material", accessor: "material", Filter: TextFilter },
      { Header: "Ref. Material", accessor: "refmaterial", Filter: TextFilter },
      { Header: "Tipo", accessor: "tipodesconto", Filter: TextFilter },
      {
        Header: "Valor",
        accessor: "valor",
        disableFilters: true,
        Cell: ({ row }) =>
          row.original.tipodesconto === "PERCENTAGEM"
            ? `${Number(row.original.valor_percentagem || 0).toFixed(3)}%`
            : `${Number(row.original.valor_eur || 0).toFixed(3)}€`,
      },
      {
        Header: "Suporte JF",
        accessor: "suporte_jf_perc",
        Filter: TextFilter,
        Cell: ({ value }) => `${Number(value || 0).toFixed(2)}%`,
      },
      {
        Header: "Suporte Fabr.",
        accessor: "suporte_fabricante_perc",
        Filter: TextFilter,
        Cell: ({ value }) => `${Number(value || 0).toFixed(2)}%`,
      },
      {
        Header: "Data inicial",
        accessor: "datainicial",
        Filter: TextFilter,
        Cell: ({ value }) => (value ? String(value).substring(0, 10) : ""),
      },
      {
        Header: "Data final",
        accessor: "datafinal",
        Filter: TextFilter,
        Cell: ({ value }) => (value ? String(value).substring(0, 10) : ""),
      },
      {
        Header: "Única",
        accessor: "utilizacao_unica",
        Filter: AtivoFilter,
        Cell: ({ value }) =>
          Number(value || 0) === 1 ? (
            <CheckCircleIcon style={{ color: "black" }} fontSize="small" />
          ) : (
            ""
          ),
      },
      { Header: "Fatura consumida", accessor: "fatura_consumida", Filter: TextFilter },
      {
        Header: "Ativo",
        accessor: "inativo",
        Filter: AtivoFilter,
        Cell: ({ value }) =>
          Number(value || 0) === 0 ? (
            <CheckCircleIcon style={{ color: "black" }} fontSize="small" />
          ) : (
            <BlockIcon style={{ color: "black" }} fontSize="small" />
          ),
      },
    ],
    [temPermissao]
  );

  const table = useTable(
    {
      columns,
      data,
      initialState: { filters: initialFilters },
      autoResetFilters: false,
      autoResetSortBy: false,
    },
    useFilters,
    useSortBy
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, setAllFilters, state } =
    table;

  useEffect(() => {
    try {
      localStorage.setItem(KEEP_KEY, JSON.stringify(keepFilters));
    } catch {}

    if (!keepFilters) {
      setAllFilters([]);
      try {
        localStorage.removeItem(FILTERS_KEY);
      } catch {}
    }
  }, [keepFilters, setAllFilters]);

  useEffect(() => {
    if (!keepFilters) return;

    try {
      localStorage.setItem(FILTERS_KEY, JSON.stringify(state.filters || []));
    } catch {}
  }, [state.filters, keepFilters]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {loading && (
        <MDBox py={2} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress />
        </MDBox>
      )}

      <PageHeader />

      <MDBox pt={1}>
        <Card>
          <MDBox p={{ xs: 1.5, md: 3 }}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems={{ xs: "stretch", md: "center" }}
              flexDirection={{ xs: "column", md: "row" }}
              gap={1}
              mb={2}
              sx={{
                "& .MuiButton-root": {
                  width: { xs: "100%", md: "auto" },
                },
              }}
            >
              <MDTypography variant="h6">Descontos adicionais cliente/material</MDTypography>

              <MDBox
                display="flex"
                alignItems={{ xs: "stretch", sm: "center" }}
                flexDirection={{ xs: "column", sm: "row" }}
                gap={1}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={keepFilters}
                      onChange={(e) => setKeepFilters(e.target.checked)}
                      size="small"
                    />
                  }
                  label="Manter filtros"
                />

                <MDButton
                  color="info"
                  disabled={!temPermissao("Menu Acordos Cliente/Fabricante", "r")}
                  onClick={abrirValorReceber}
                >
                  Valor a receber
                </MDButton>

                <MDButton
                  color="success"
                  disabled={!temPermissao("Menu Acordos Cliente/Fabricante", "w")}
                  onClick={abrirNovo}
                >
                  Novo desconto
                </MDButton>
              </MDBox>
            </MDBox>

            <MDBox sx={{ height: "68vh", overflow: "auto", borderRadius: 1, maxWidth: "100%" }}>
              <table
                {...getTableProps()}
                style={{ width: "100%", minWidth: 1450, borderCollapse: "collapse" }}
              >
                <thead>
                  {headerGroups.map((hg) => (
                    <tr {...hg.getHeaderGroupProps()}>
                      {hg.headers.map((col) => (
                        <th
                          {...col.getHeaderProps(col.getSortByToggleProps())}
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 2,
                            background: "#fff",
                            textAlign: "left",
                            padding: "6px 8px",
                            fontSize: 12,
                            color: "#7b809a",
                            verticalAlign: "bottom",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.06)",
                            width: col.id === "acoes" ? 72 : undefined,
                          }}
                        >
                          <div>
                            {col.render("Header")}
                            {col.isSorted ? (col.isSortedDesc ? " ▼" : " ▲") : null}
                          </div>

                          {!col.disableFilters && (
                            <div onClick={(e) => e.stopPropagation()} style={{ marginTop: 4 }}>
                              {col.canFilter ? col.render("Filter") : null}
                            </div>
                          )}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody {...getTableBodyProps()}>
                  {rows.map((row) => {
                    prepareRow(row);

                    return (
                      <tr {...row.getRowProps()}>
                        {row.cells.map((cell) => (
                          <td
                            {...cell.getCellProps()}
                            style={{
                              padding: "8px 10px",
                              borderTop: "1px solid #eee",
                              fontSize: 12,
                              color: "#1a2b4c",
                              width: cell.column.id === "acoes" ? 72 : undefined,
                              whiteSpace: "nowrap",
                            }}
                          >
                            {cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </MDBox>
          </MDBox>
        </Card>
      </MDBox>

      <Dialog
        open={openDialogValorReceber}
        onClose={() => setOpenDialogValorReceber(false)}
        maxWidth="xl"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          Valor a receber do fabricante
        </DialogTitle>

        <DialogContent>
          <MDBox display="grid" gap={1.5} mt={1}>
            <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "2fr 1fr 1fr" }} gap={1.5}>
              <div>
                <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Fabricante</div>

                <Autocomplete
                  size="small"
                  options={fabricantesAcordosCombo}
                  filterOptions={(x) => x}
                  inputValue={valorFabricanteInput}
                  getOptionLabel={fabricanteLabel}
                  value={
                    fabricantesAcordosCombo.find((f) => f.ref === valorReceberForm.reffabricante) ||
                    null
                  }
                  onInputChange={(_, value, reason) => {
                    if (reason === "input") {
                      setValorFabricanteInput(value);
                      setValorReceberForm((p) => ({ ...p, reffabricante: "" }));
                      carregarFabricantesAcordosCombo(value);
                    }

                    if (reason === "clear") {
                      setValorFabricanteInput("");
                      setValorReceberForm((p) => ({ ...p, reffabricante: "" }));
                    }
                  }}
                  onChange={(_, value) => {
                    setValorReceberForm((p) => ({ ...p, reffabricante: value?.ref || "" }));
                    setValorFabricanteInput(value ? fabricanteLabel(value) : "");
                  }}
                  renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
                />
              </div>

              <div>
                <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Data inicial</div>

                <MDInput
                  type="date"
                  value={valorReceberForm.datainicial}
                  onChange={(e) =>
                    setValorReceberForm((p) => ({
                      ...p,
                      datainicial: e.target.value,
                    }))
                  }
                  fullWidth
                />
              </div>

              <div>
                <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Data final</div>

                <MDInput
                  type="date"
                  value={valorReceberForm.datafinal}
                  onChange={(e) =>
                    setValorReceberForm((p) => ({
                      ...p,
                      datafinal: e.target.value,
                    }))
                  }
                  fullWidth
                />
              </div>
            </MDBox>

            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              gap={1}
              flexWrap="wrap"
            >
              <MDBox
                display="flex"
                // justifyContent="space-between"
                alignItems="center"
                gap={1}
                flexWrap="wrap"
              >
                <MDButton color="info" onClick={consultarValorReceber}>
                  Consultar
                </MDButton>

                <MDButton
                  startIcon={
                    loadingExcelValorReceber ? (
                      <CircularProgress size={16} color="inherit" />
                    ) : (
                      <TableViewIcon />
                    )
                  }
                  color="success"
                  onClick={exportarValorReceberExcel}
                  disabled={loadingExcelValorReceber}
                >
                  {loadingExcelValorReceber ? "A gerar Excel..." : "Exportar Excel"}
                </MDButton>
              </MDBox>

              <MDTypography variant="h6">
                Total a receber: {formatarValor(totalValorReceberFabricante)} €
              </MDTypography>
            </MDBox>

            <MDBox sx={{ maxHeight: "50vh", overflow: "auto", borderRadius: 1, maxWidth: "100%" }}>
              <table style={{ width: "100%", minWidth: 2100, borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    {[
                      "Cliente",
                      "Ref. Cliente",
                      "Material",
                      "Ref. Material",
                      "Data",
                      "Fatura",
                      "Estornada",
                      "Fatura Estornada",
                      // "Cat.",
                      "Qtd",
                      "Preço Acons.",
                      "Tipo",
                      "Valor %",
                      "Valor €",
                      "Suporte JF",
                      "Suporte Fabr.",
                      "Valor Receber",
                    ].map((h) => (
                      <th
                        key={h}
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          background: "#fff",
                          textAlign: "left",
                          padding: "6px 8px",
                          fontSize: 12,
                          color: "#7b809a",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.06)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {valorReceberData.map((row, idx) => (
                    <tr key={`${row.idacordo}-${row.faturanumero}-${idx}`}>
                      {[
                        row.cliente,
                        row.refcliente,
                        row.material,
                        row.refmaterial,
                        row.faturadata ? String(row.faturadata).substring(0, 10) : "",
                        row.faturanumero,
                        row.estornada,
                        row.faturaestornada,
                        // row.catitemnome,
                        `${row.qtd} ${row.qtdunid || ""}`,
                        formatarValor(row.precoaconselhado),
                        row.tipodesconto,
                        row.valor_percentagem == null
                          ? ""
                          : `${formatarValor(row.valor_percentagem)}%`,
                        row.valor_eur == null ? "" : `${formatarValor(row.valor_eur)} €`,
                        `${formatarValor(row.suporte_jf_perc)}%`,
                        `${formatarValor(row.suporte_fabricante_perc)}%`,
                        `${formatarValor(row.valor_receber_fabricante)} €`,
                      ].map((value, i) => (
                        <td
                          key={i}
                          style={{
                            padding: "8px 10px",
                            borderTop: "1px solid #eee",
                            fontSize: 12,
                            whiteSpace: "nowrap",
                            fontWeight: i === 15 ? 700 : undefined,
                          }}
                        >
                          {value}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </MDBox>
          </MDBox>
        </DialogContent>

        <DialogActions sx={{ flexWrap: "wrap", gap: 1 }}>
          <MDButton color="secondary" onClick={() => setOpenDialogValorReceber(false)}>
            Fechar
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          {editando ? "Editar desconto adicional" : "Novo desconto adicional"}
        </DialogTitle>

        <DialogContent>
          <MDBox display="grid" gap={1.5} mt={1}>
            <div>
              <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Cliente</div>

              <Autocomplete
                size="small"
                options={clientesCombo}
                filterOptions={(x) => x}
                inputValue={clienteInput}
                getOptionLabel={clienteLabel}
                value={clientesCombo.find((c) => c.ref === form.refcliente) || null}
                onInputChange={(_, value, reason) => {
                  if (reason === "input") {
                    setClienteInput(value);
                    setForm((p) => ({ ...p, refcliente: "" }));
                    carregarClientesCombo(value);
                  }

                  if (reason === "clear") {
                    setClienteInput("");
                    setForm((p) => ({ ...p, refcliente: "" }));
                  }
                }}
                onChange={(_, value) => {
                  setForm((p) => ({ ...p, refcliente: value?.ref || "" }));
                  setClienteInput(value ? clienteLabel(value) : "");
                }}
                renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
              />
            </div>

            <div>
              <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Fabricante</div>

              <Autocomplete
                size="small"
                options={fabricantesCombo}
                filterOptions={(x) => x}
                inputValue={fabricanteInput}
                getOptionLabel={fabricanteLabel}
                value={fabricantesCombo.find((f) => f.ref === form.reffabricante) || null}
                onInputChange={(_, value, reason) => {
                  if (reason === "input") {
                    setFabricanteInput(value);
                    setForm((p) => ({ ...p, reffabricante: "" }));
                    carregarFabricantesCombo(value);
                  }

                  if (reason === "clear") {
                    setFabricanteInput("");
                    setForm((p) => ({ ...p, reffabricante: "" }));
                  }
                }}
                onChange={(_, value) => {
                  setForm((p) => ({ ...p, reffabricante: value?.ref || "" }));
                  setFabricanteInput(value ? fabricanteLabel(value) : "");
                }}
                renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
              />
            </div>

            <div>
              <div style={{ fontSize: 12, color: "#7b809a", marginBottom: 4 }}>Material</div>

              <Autocomplete
                size="small"
                options={materiaisCombo}
                filterOptions={(x) => x}
                inputValue={materialInput}
                getOptionLabel={materialLabel}
                value={materiaisCombo.find((m) => m.ref === form.refmaterial) || null}
                onInputChange={(_, value, reason) => {
                  if (reason === "input") {
                    setMaterialInput(value);
                    setForm((p) => ({ ...p, refmaterial: "" }));
                    carregarMateriaisCombo(value);
                  }

                  if (reason === "clear") {
                    setMaterialInput("");
                    setForm((p) => ({ ...p, refmaterial: "" }));
                  }
                }}
                onChange={(_, value) => {
                  setForm((p) => ({ ...p, refmaterial: value?.ref || "" }));
                  setMaterialInput(value ? materialLabel(value) : "");
                }}
                renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
              />
            </div>

            <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr 1fr" }} gap={1.5}>
              <div>
                <select
                  title="Tipo de desconto"
                  value={form.tipodesconto}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      tipodesconto: e.target.value,
                      valor_percentagem: "",
                      valor_eur: "",
                    }))
                  }
                  style={{
                    height: 44,
                    padding: "0 12px",
                    borderRadius: 6,
                    border: "1px solid #d2d6da",
                    width: "100%",
                    marginTop: 1,
                    fontSize: 14,
                    background: "#fff",
                  }}
                >
                  <option value="PERCENTAGEM">Percentagem</option>
                  <option value="VALOR">Valor em euros</option>
                </select>
              </div>

              {form.tipodesconto === "PERCENTAGEM" ? (
                <MDInput
                  type="number"
                  placeholder="Valor %"
                  value={form.valor_percentagem}
                  onChange={(e) => setForm((p) => ({ ...p, valor_percentagem: e.target.value }))}
                  fullWidth
                />
              ) : (
                <MDInput
                  type="number"
                  placeholder="Valor €"
                  value={form.valor_eur}
                  onChange={(e) => setForm((p) => ({ ...p, valor_eur: e.target.value }))}
                  fullWidth
                />
              )}

              <FormControlLabel
                control={
                  <Checkbox
                    checked={Number(form.utilizacao_unica || 0) === 1}
                    onChange={(e) =>
                      setForm((p) => ({
                        ...p,
                        utilizacao_unica: e.target.checked ? 1 : 0,
                      }))
                    }
                    size="small"
                  />
                }
                label="Utilização única"
              />
            </MDBox>

            <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5}>
              <MDInput
                label="Suporte JF %"
                type="number"
                value={form.suporte_jf_perc}
                onChange={(e) => {
                  const jf = Number(e.target.value || 0);
                  setForm((p) => ({
                    ...p,
                    suporte_jf_perc: e.target.value,
                    suporte_fabricante_perc: 100 - jf,
                  }));
                }}
                fullWidth
              />

              <MDInput
                label="Suporte fabricante %"
                type="number"
                value={form.suporte_fabricante_perc}
                onChange={(e) => {
                  const fab = Number(e.target.value || 0);
                  setForm((p) => ({
                    ...p,
                    suporte_fabricante_perc: e.target.value,
                    suporte_jf_perc: 100 - fab,
                  }));
                }}
                fullWidth
              />
            </MDBox>

            {Number(form.utilizacao_unica || 0) !== 1 && (
              <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5}>
                <MDInput
                  label="Data inicial"
                  type="date"
                  value={form.datainicial}
                  onChange={(e) => setForm((p) => ({ ...p, datainicial: e.target.value }))}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />

                <MDInput
                  label="Data final"
                  type="date"
                  value={form.datafinal}
                  onChange={(e) => setForm((p) => ({ ...p, datafinal: e.target.value }))}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                />
              </MDBox>
            )}

            <MDInput
              label="Observações"
              value={form.obs}
              onChange={(e) => setForm((p) => ({ ...p, obs: e.target.value }))}
              fullWidth
              multiline
              rows={3}
            />

            {editando && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={Number(form.inativo || 0) === 1}
                    onChange={(e) => setForm((p) => ({ ...p, inativo: e.target.checked ? 1 : 0 }))}
                    size="small"
                  />
                }
                label="Inativo"
              />
            )}
          </MDBox>
        </DialogContent>

        <DialogActions sx={{ flexWrap: "wrap", gap: 1 }}>
          <MDButton color="secondary" onClick={() => setOpenDialog(false)}>
            Cancelar
          </MDButton>

          <MDButton color="success" onClick={guardar}>
            Gravar
          </MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}
